<template>
  <AnalyticsCard
    title="How far ahead people book"
    subtitle="Notice between booking and meeting"
    :loading="loading"
    :empty="isEmpty"
    empty-title="No bookings in this period"
    empty-hint="This is the answer to how far out to open availability."
    :height="264"
  >
    <div ref="el" class="w-full h-64"></div>
  </AnalyticsCard>
</template>

<script setup>
import { computed, toRef } from 'vue'
import AnalyticsCard from '../shared/AnalyticsCard.vue'
import { useAnalyticsChart, baseOptions, PALETTE } from '../shared/useAnalyticsChart.js'

const props = defineProps({
  data:    { type: Array, default: () => [] },   // [{ bucket, count }]
  loading: { type: Boolean, default: false },
})

const isEmpty = computed(() => !props.loading && props.data.every(d => !d.count))

const { el } = useAnalyticsChart((_node, tokens) => {
  if (!props.data.length) return null
  const base = baseOptions(tokens)

  return {
    ...base,
    chart: { ...base.chart, type: 'column', height: 256, spacing: [16, 16, 8, 4] },
    xAxis: {
      ...base.xAxis,
      categories: props.data.map(d => d.bucket),
      labels: { style: { color: tokens.text, fontSize: '10px' }, rotation: -35 },
    },
    yAxis: { ...base.yAxis, min: 0, allowDecimals: false },
    tooltip: {
      ...base.tooltip,
      headerFormat: '',
      pointFormat: '<b>{point.category}</b><br>{point.y} bookings',
    },
    plotOptions: {
      column: { borderWidth: 0, borderRadius: 4, pointPadding: 0.08, groupPadding: 0.12, color: PALETTE.violet },
    },
    series: [{ name: 'Bookings', data: props.data.map(d => d.count) }],
  }
}, [toRef(props, 'data')])
</script>
